import Icon from '../components/Icon.vue'

Icon.register({
  'shield-alt': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M496 128C496 349.3 360.1 472.6 274.5 508.3A48-48 0 0 0 237.5 508.3C130.5 463.7 16 326.5 16 128A48-48 0 0 0 45.5 83.7L237.5 3.7A48-48 0 0 0 274.5 3.7L466.5 83.7A48-48 0 0 0 496 128zM256 446.3L256.1 446.3C349.8 399.7 428.6 290 431.9 138.6L256 65.3V446.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/shield-alt.js
// module id = xYof
// module chunks = 144